import { KioskCommand } from './postKioskApi';
import { usePostKioskApi } from './usePostKioskApi';

export async function resetPin(employeeId: number, mode: ResetPinMode) {
  const postKioskApi = usePostKioskApi();
  return await postKioskApi(KioskCommand.resetEmployeePin, {
    Id: employeeId,
    Mode: mode,
  });
}

export enum ResetPinMode {
  Email,
  SMS,
}
// resetPin API can response with this message if passed incorrect options
export const resetPinResponseErrorMessage =
  'We cannot process your request. Please make sure your email or mobile is set correctly and Kiosk is online.';
export const resetPinResponseEmailErrorMessage =
  'Sorry, you have not set your email yet, please choose another option or contact your supervisor.';
export const resetPinResponseMobileErrorMessage =
  'Sorry, you have not set your mobile yet, please choose another option or contact your supervisor.';
